import { QuestionType2UIConfig } from "../../../../../components/ui/question-type2-ui";
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../../../../../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { ScoringType } from "../../../../../misc/tools";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import { scenario8RmeTempHumAudioCaching, scenario8RmeTempHumVideoSegments } from "../../../scenario8-rme-temp-hum";
import { RmeTempHumComponentsStep2ComponentPart1Config, RmeTempHumComponentsStep2ComponentMainConfig } from "../RmeTempHumComponentsStep2Component";

export default class RmeTempHumComponentsStep2Part1 extends BaseScenarioPart<GameBaseScenario> {

	private stepName="Step 3"
	private get config(): RmeTempHumComponentsStep2ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: RmeTempHumComponentsStep2ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType2UI({
			title: this.mainConfig.scenario.props.name,
			audioUrl: scenario8RmeTempHumAudioCaching.getItemByKey(scenario8RmeTempHumAudioCaching.audioKeys.question5).src,
			subtitle: this.stepName,
			isYesCorrect: false,
			correctFeedback: `
				<p class="default-text">Correct. There is no history involving this type of behavior or decision making with this employee.</p>
			`,
			wrongFeedback: `
				<p class="default-text">This is not the best option. Nurse Joan has not previously been involved in a similar incident.</p>
			`,
			question: 'Were there repetitive occurrences with this type of behavior involving the employee?',
			onSubmitClicked: (isCorrect: boolean, feedback: string, selectedTitle: string, parentQuestion: QuestionType2UIConfig) => {
				const mentorInfo = scenario8RmeTempHumVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType2(isCorrect, feedback, selectedTitle, this.stepName, parentQuestion, () => {
					context.section2();
				}, () => {
					context.section2();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[11], mentorInfo.chapterIds[12]);
			}
		}, 4);
	}

	public section2() {
		const context = this;
        this.mainConfig.scenario.setAreaForCurrentScenario(5);
		this.mainConfig.scenario.uiWrapper.displayIntroScreenUI({
			title: 'Re-Cap Summary Statement',
			subtitle: 'Scenario 8 - Reusable Medical Equipment (RME)',
			recapFirst: 'In summary this is “At-Risk.” ',
			htmlData: `
				<br/><li>The substitution test is satisfied. 
				<br/><br/></li><li>Accountability is shared with leadership and the employee. 
				<br/><br/></li><li>There is no history involving this type of behavior from this employee. 
				<br/><br/></li><li>Employee should be consoled. 
				<br/><br/></li><li>Leadership should take steps to correct system and or cultural issues.</li>
			`,
			okButton: 'Continue',
			onStartScenarioClicked: () => {
				context.onDone();
			},
			mentorUrl: scenario8RmeTempHumVideoSegments.getItemByKey('Feedback').src,
			mentorChapter: scenario8RmeTempHumVideoSegments.getItemByKey('Feedback').chapterIds[14]
		})
	}
}